import type { HelpFile } from '../../types/help'
import { AccessProfileCreateTestIds } from '../../../testids/AccessProfileCreateTestIds'

export const accessProfileCreateHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfileCreateTestIds.accessProfileCreatePage]:
      'Define a new access profile — name, code, risk level, and the enforcement objects it grants on target systems.',
  },
}
